module.exports = __webpack_public_path__ + "img/crystal-ball.5e631cc3.svg";